// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_AUTHORIZATION_TIMEOUT_MS = 120000;
export var AUTHORIZATION_CALLBACK_MESSAGE_TYPE = 'flow_payment_inline_callback';
export var CALLBACK_ORIGIN = 'https://pay.flow.io';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/constants.js
// module id = 209
// module chunks = 0 1